import { useTranslation } from 'react-i18next';
import { feedbackSystem } from '@/mocks/trainingData';

const STEP_COUNT = 4;

export default function FeedbackSystem() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            {String(t('training.feedback.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
              {t('training.feedback.title')}
            </h2>
            {String(t('training.feedback.sectionTitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
            <div className="gold-line mb-6"></div>

            {String(t('training.feedback.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-8">{__s}</p>))}

            <div className="space-y-5">
              {Array.from({ length: STEP_COUNT }, (_, idx) => (
                <div key={idx} className="flex gap-4">
                  <div className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-accent-400 font-heading text-[13px] tracking-[0.06em]">
                    {feedbackSystem.steps[idx].step}
                  </div>
                  <div>
                    <h4 className="text-[15px] text-foreground-800 tracking-[0.04em] font-medium mb-1">
                      {t(`training.feedback.${idx}.title`)}
                      <span className="text-[9px] text-accent-500/60 tracking-[0.1em] ml-2">{t(`training.feedback.${idx}.titleEn`)}</span>
                    </h4>
                    <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                      {t(`training.feedback.${idx}.description`)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative w-full aspect-[4/3] overflow-hidden">
            <img
              src="/images/generated/training-feedback-2026.jpg"
              alt={t('training.feedback.imgAlt')}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            {String(t('training.feedback.imgCaption')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[12px] text-foreground-400 tracking-[0.04em] mt-2 text-center">{__s}</p>))}
          </div>
        </div>
      </div>
    </section>
  );
}
